export async function bookingError(reason: unknown): Promise<string> {
  const response = (reason as { response?: Response })?.response;
  if (!response) return 'Unable to save. Your draft is retained. Please try again.';
  try {
    const flatten = (value: unknown): string[] => typeof value === 'string' ? [value]
      : Array.isArray(value) ? value.flatMap(flatten)
      : value && typeof value === 'object' ? Object.values(value).flatMap(flatten) : [];
    return flatten(await response.json()).join(' ') || 'Unable to save this booking.';
  } catch { return 'Unable to save this booking. Reload and try again.'; }
}
